import classNames from "classnames";
import * as React from "react";
import { RowCheckMark } from "~/sharedComponents/list/ListRowDefault";
import { Icon, icon, IconNames } from "../../sharedComponents/icons";
import { AvatarSizes, SpriteAvatar } from "../avatar/SpriteAvatar";
import { VirtListRowProps } from "../list/BaseList";
import { UserItem } from "../members/types";
import { UserName } from "../users/UserName";
import * as styles from "./UserListRow.less";
import { UserRole } from "./UserRole";

type Props = VirtListRowProps<UserItem> & {
    isSelected?: boolean;
    className?: string;
    roleEditor?: React.ComponentType;
};

const UserIcon: React.FC<{ icon: IconNames }> = ({ icon }) => (
    <div className={styles.iconRoleWrapper}>
        <Icon iconName={icon} />
    </div>
);
UserIcon.displayName = "UserIcon";

const defaultHeight = 36;
const detailedRowHeight = 48;

const createUserListRow = (withDetails: boolean) => {
    const avatarSize = withDetails ? AvatarSizes.Medium : AvatarSizes.Small;

    type ComponentType = React.FC<Props> & {
        rowHeight: number;
    };

    const UserListRow: ComponentType = props => {
        const { item, isFocused, textForHighlight, isSelected, className, roleEditor, children } = props;
        const isDisabled = item.IsEnabled === false;
        const userIcon = item.IsManager ? icon.case : null;

        const rowStyle = classNames(
            className,
            styles.row,
            withDetails && styles.detailed_row,
            isFocused && styles.focused
        );

        return (
            <div className={rowStyle} data-testid="user_row">
                <SpriteAvatar
                    size={avatarSize}
                    userId={item.UserId}
                    unnamedResourceId={item.UnnamedResourceId}
                    disabled={isDisabled}
                />
                {!!userIcon && <UserIcon icon={userIcon} />}
                <div className={styles.info}>
                    <UserName
                        name={item.Name}
                        className={styles.name}
                        textForHighlight={textForHighlight}
                        disabled={isDisabled}
                    />
                    <UserRole withDetails={withDetails} roleEditor={roleEditor} roleName={item.RoleName} />
                </div>
                <RowCheckMark selected={isSelected} />
                {children}
            </div>
        );
    };

    UserListRow.displayName = withDetails ? "DetailedUserListRow" : "UserListRow";
    UserListRow.rowHeight = withDetails ? detailedRowHeight : defaultHeight;

    return UserListRow;
};

export const UserListRow = createUserListRow(false);
export const DetailedUserListRow = createUserListRow(true);
